import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useEffect } from "react";

const oilDescriptions = {
  "Onion oil": `Onion oil is widely used in hair care and cosmetic formulations for its nourishing and strengthening properties. It is commonly utilized in shampoos, serums, conditioners, scalp treatments, and hair growth products. Rich in naturally occurring compounds, onion oil is valued in the personal care industry for formulations focused on scalp nourishment, hair strengthening, and overall hair care support.

Our onion oil is sourced from trusted suppliers and processed under strict quality control standards to ensure purity, consistency, and reliability for industrial applications. It is suitable for a wide range of cosmetic and wellness formulations and can be used in both standalone and blended oil products.

We provide flexible bulk supply solutions tailored to client requirements, including customized quantities, packaging options, and timely dispatch. With a strong focus on quality assurance and long-term business relationships, we ensure dependable procurement support for manufacturers, wholesalers, cosmetic brands, and distributors across India.`,

  "Hibiscus oil": `Hibiscus oil is a premium botanical oil widely used in hair care, cosmetic, and personal wellness formulations for its nourishing and conditioning properties. It is commonly incorporated into hair oils, shampoos, scalp treatments, serums, conditioners, and herbal cosmetic products. Known for its traditional use in hair care applications, hibiscus oil is valued for formulations focused on scalp nourishment, hair smoothness, and overall hair maintenance.

Our hibiscus oil is sourced from trusted suppliers and processed under strict quality control standards to ensure purity, consistency, and reliability for industrial applications. It is suitable for a wide range of cosmetic and wellness formulations and can be used in both standalone and blended oil products.

We offer flexible bulk supply solutions tailored to client requirements, including customized quantities, packaging options, and timely dispatch. With a strong commitment to quality assurance and long-term business partnerships, we ensure dependable procurement support for manufacturers, wholesalers, cosmetic brands, and distributors across India.`,
};

const OilDetails = () => {
  const { state } = useLocation();

  const navigate = useNavigate();

  // Browser tab title fix
  useEffect(() => {
    if (state?.name) {
      document.title =
        `${state.name} Supplier | Aranya Nutraceuticals`;
    } else {
      document.title =
        "Product Not Found | Aranya Nutraceuticals";
    }
  }, [state]);

  // If state missing
  if (!state) {
    return (
      <>
        <Helmet>
          <title>
            Product Not Found | Aranya Nutraceuticals
          </title>

          <meta
            name="description"
            content="Requested product page not found."
          />
        </Helmet>

        <div className="p-10">
          <p>Product not found</p>
        </div>
      </>
    );
  }

  const description =
    oilDescriptions[state.name?.trim()] ||
    "High-quality essential oil available for industrial and bulk supply requirements.";

  return (
    <>
      {/* SEO */}
      <Helmet>
        <title>
          {state.name} Supplier | Aranya Nutraceuticals
        </title>

        <meta
          name="description"
          content={`${state.name} supplier in India for cosmetic, wellness, and industrial applications. Premium quality bulk supply with reliable sourcing and packaging.`}
        />

        <meta
          name="keywords"
          content={`${state.name}, essential oil supplier, herbal oils, cosmetic oils, bulk oil supplier`}
        />

        <meta
          property="og:title"
          content={`${state.name} Supplier | Aranya Nutraceuticals`}
        />

        <meta
          property="og:description"
          content={`Premium quality ${state.name} supplier for cosmetic and wellness formulations.`}
        />

        <meta
          property="og:image"
          content={state.img}
        />

        <meta property="og:type" content="website" />
      </Helmet>

      <div className="min-h-screen px-4 md:px-10 py-8 md:py-12 bg-gray-50">

        {/* Back Button */}
        <button
          onClick={() => navigate(-1)}
          className="mb-6 text-green-600 hover:underline"
        >
          ← Back
        </button>

        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8 items-start">

          {/* Image */}
          <img
            src={state.img}
            alt={state.name}
            loading="eager"
            width="600"
            height="400"
            className="w-full h-72 md:h-[400px] object-cover rounded shadow"
          />

          {/* Content */}
          <div>

            <h1 className="text-2xl md:text-3xl font-bold mb-4">
              {state.name}
            </h1>

            <p className="text-gray-700 leading-relaxed text-sm md:text-base">
              {description}
            </p>

          </div>
        </div>
      </div>
    </>
  );
};

export default OilDetails;